import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import * as Color from "./../../../../utils/Colors";

const lineStyle = {
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage: "linear-gradient( 95deg, " + Color.default.OLIVE + " 30%," + Color.default.OLIVETONE + " 100%)",
    },
  },
  completed: {
    "& $line": {
      backgroundColor: Color.default.OLIVE,
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: Color.default.BRIGHT_GRAY,
    borderRadius: 1,
  },
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    conteredContentContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },

    stepperRoot: {
      backgroundColor: Color.default.SILVER_SAND,
      zIndex: 1,
      color: Color.default.WHITE,
      width: 45,
      height: 45,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
    },
    stepperActive: {
      backgroundImage: "linear-gradient( 136deg, " + Color.default.OLIVE + " 30%," + Color.default.OLIVETONE + " 100%)",
      boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
    },
    stepperCompleted: {
      backgroundColor: Color.default.OLIVE,
    },
  })
);

export { useStyles, lineStyle };
